import script from "./IconUploadSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./IconUploadSelector.vue?vue&type=script&setup=true&lang=js"

import "./IconUploadSelector.vue?vue&type=style&index=0&id=04ccb69f&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ccb69f"]])

export default __exports__